<template>
  <section>
    <div class="px-4 sm:px-6 lg:px-8" v-show="!showList">
      <ul role="list" class="-mb-8">
        <li>
          <div class="relative pb-8">
            <span class="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" v-if="promotion_code !== ''"></span>
            <div class="relative flex space-x-3">
              <div>
                <span class="h-8 w-8 rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white">
                  <svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd" />
                  </svg>
                </span>
              </div>
              <div class="min-w-0 flex-1 pt-1.5">
                <div v-if="promotion_code !== ''">
                  <p class="text-sm text-gray-500">专属推广邀请码</p>
                  <p class="text-sm text-orange-500 mt-4 lg:text-3xl font-bold">
                    {{promotion_code}}
                  </p>
                  <div class="text-sm text-gray-500 flex space-x-1 items-center">
                    <div>您的专属推广链接：</div>
                    <div class="underline underline-offset-1">https://www.huoyuyan.com/?aff={{promotion_code}}</div>
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" @click="copy('https://www.huoyuyan.com/?aff='+promotion_code)" title="点击复制邀请码">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-4 w-4 text-gray-500">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0118 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3l1.5 1.5 3-3.75" />
                      </svg>
                    </a>
                  </div>
                </div>
                <div v-else>
                  <p class="text-sm text-gray-500">生成专属邀请码</p>
                  <button @click="applyCode" type="button" class="mt-4 inline-flex items-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">立即申请</button>
                </div>

              </div>
            </div>
          </div>
        </li>

        <li v-if="promotion_code !== ''">
          <div class="relative pb-8">
            <span class="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
            <div class="relative flex space-x-3">
              <div>
                <span class="h-8 w-8 rounded-full bg-blue-500 flex items-center justify-center ring-8 ring-white">
                  <svg class="h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 22" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 6h.008v.008H6V6z" />
                  </svg>
                </span>
              </div>
              <div class="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4">
                <div>
                  <div class="text-sm text-gray-500">
                    <div>查看积分推广消费活动</div>
                  </div>
                  <div class="activity-list mt-4" v-if="tableData.length">
                    <p class="text-base" v-if="tableData[0]">1. {{ tableData[0].Title }}</p>
                    <p class="text-base" v-if="tableData[1]">2. {{ tableData[1].Title }}</p>
                    <p class="text-base" v-if="tableData[2]">3. {{ tableData[2].Title }}</p>
                    <p class="text-base" v-if="tableData[3]">4. {{ tableData[3].Title }}</p>
                    <p class="text-base" v-if="tableData[4]">5. {{ tableData[4].Title }}</p>
                    <p class="text-base">...</p>
                    <div class="mt-2 relative">
                      <button @click="showList = true" type="button" class="mt-4 inline-flex items-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
                        查看更多
                        <div class="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-red-500 border-2 border-white rounded-full top-2 right-12 dark:border-gray-900">{{ total }}</div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>

        <li v-if="promotion_code !== ''">
          <div class="relative pb-8">
            <div class="relative flex space-x-3">
              <div>
                <span class="h-8 w-8 rounded-full bg-green-500 flex items-center justify-center ring-8 ring-white">
                  <svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                  </svg>
                </span>
              </div>
              <div class="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4">
                <div>
                  <p class="text-sm text-gray-500">发布推广链接</p>
                  <p class="mt-4 text-base">QQ群、微信等社交软件及网站上分享您的专属链接，获取更多的积分，共筑火语言平台新生态。</p>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="px-4 sm:px-6 lg:px-8" v-show="showList">
      <!-- <div class="hidden sm:block pb-4">
        <nav class="flex space-x-4" aria-label="Tabs">
          <a href="#" @click="query.status = 1" :class="[query.status === 1? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700']" class="px-3 py-2 font-medium text-sm rounded-md">进行中的活动</a>
          <a href="#" @click="query.status = -2" :class="[query.status === -2 ? 'bg-indigo-100 text-indigo-700' : 'text-gray-500 hover:text-gray-700']" class="px-3 py-2 font-medium text-sm rounded-md">已结束的活动</a>
        </nav>
      </div> -->
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <select v-model="query.status" name="country" autocomplete="country-name" class="sm:hidden mt-1 mr-4 w-48 inline-block bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
            <option :value="4" :selected="query.status === 1">进行中</option>
            <option :value="0" :selected="query.status === -2">已结束</option>
          </select>
          <input v-model="query.keyword" type="text" name="first-name" placeholder="关键字筛选" autocomplete="given-name" class="mt-1 mr-4 inline-block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
          <!-- <button @click="getList()" type="button" class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">查询</button> -->
        </div>
      </div>
      <div class="mt-4 flex flex-col">
        <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <table class="min-w-full divide-y divide-gray-300">
                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">活动标题</th>
                    <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">状态</th>
                    <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">积分</th>
                    <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">活动时间</th>
                    <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                      <span class="sr-only">操作</span>
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 bg-white">
                  <tr v-for="item in tableData" :key="item.id">
                    <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">{{item.Title}}</td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm" :class="statusMap[item.Status].class">{{statusMap[item.Status].text}}</td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                      <span v-if="item.Score < 0" class="text-green-600">{{item.Score}}</span>
                      <span v-else-if="item.Score > 0" class="text-red-600">+{{item.Score}}</span>
                      <span v-else>{{item.Score}}</span>
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.StartTime}} - {{item.EndTime}}</td>
                    <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                      <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" title="查看活动详情" @click="view(item)">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607zM10.5 7.5v6m3-3h-6" />
                        </svg>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Pagination :size="query.PageSize" :page="query.PageIndex" :total="total" @change="changePage" />
      <Modal :visible.sync="versionDialog" title="活动详情" :ActionBtnShow="false" width="max-w-3xl">
        <div class="space-y-6 sm:space-y-0 sm:py-0 my-4 mx-2 ring-1 ring-black ring-opacity-5">
          <dl>
            <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt class="text-sm font-medium text-gray-500">活动标题</dt>
              <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{{row.Title || '--'}}</dd>
            </div>
            <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt class="text-sm font-medium text-gray-500">活动介绍</dt>
              <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{{row.Introduction}}</dd>
            </div>
            <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt class="text-sm font-medium text-gray-500">积分</dt>
              <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{{row.Score || '--'}}</dd>
            </div>
            <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt class="text-sm font-medium text-gray-500">活动时间</dt>
              <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{{row.StartTime}} - {{row.EndTime}}</dd>
            </div>
            <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt class="text-sm font-medium text-gray-500">Key</dt>
              <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{{row.Key || '--'}}</dd>
            </div>
          </dl>
        </div>
      </Modal>
    </div>
    <Alert :visible.sync="alertShow" ref="alert" />
    <Notify ref="notify" />
  </section>
</template>

<script>
import Pagination from '../components/Pagination.vue'
import Alert from '../components/Alert.vue'
import Notify from '../components/Notification.vue'
import { pageList, applyCode, getDetail, pageListPromotion } from '../api/Extend'
import { getCurrentUser } from '../api/App'
import { debounce } from 'lodash'
import Modal from '../components/Modal.vue'
export default {
  name: 'ExtendList',
  components: { Alert, Notify, Pagination, Modal },
  data () {
    return {
      alertShow: false,
      modalShow: false,
      versionDialog: false,
      showList: false,
      promotion_code: '',
      promotion: {
        UserCount: 0,
        TotalOrderAmount: 0,
        TotalRebateAmount: 0,
        MonthRebateAmount: 0,
        WithdrawalAmount: 0
      },
      query: {
        PageIndex: 1,
        PageSize: 20,
        Keyword: ''
        // Sort: 'Status'
        // Status: 1
      },
      key: '',
      versions: [],
      tableData: [],
      total: 0,
      relationsData: {
        main: { name: '' },
        logics: [],
        components: [],
        complexs: []
      },
      PromotionTableData: [],
      row: {},
      statusMap: {
        '1': {
          class: 'text-green-600',
          text: '进行中'
        },
        '0': {
          class: 'text-gray-500',
          text: '未开始'
        },
        '-1': {
          class: 'text-red-600',
          text: '已结束'
        },
        '-2': {
          class: 'text-red-600',
          text: '已过期'
        }
      }
    }
  },
  mounted () {
    this.getList()
    this.getPromotionList()
    const userString = localStorage.getItem('hyy_www_user')
    if (userString) {
      const user = JSON.parse(userString)
      if (user && user.promotion_code) this.promotion_code = user.promotion_code
    }
    this.showList = false
  },
  methods: {
    getPromotionList () {
      pageListPromotion().then(res => {
        this.PromotionTableData = res.data.data.list
      })
    },
    copy (text) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.notifyShow({ title: '专属推广邀请码已复制到剪切板', desc: '' })
          })
          .catch((err) => {
            console.error('无法复制此文本：', err)
          })
      } else {
        // 创建text area
        const textArea = document.createElement('textarea')
        textArea.value = text
        document.body.appendChild(textArea)
        textArea.style.position = 'absolute'
        textArea.style.opacity = 0
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        textArea.focus()
        textArea.select()
        return new Promise((resolve, reject) => {
          // 执行复制命令并移除文本框
          document.execCommand('copy') ? resolve() : reject(new Error('出错了'))
          textArea.remove()
        }).then(
          () => {
            this.notifyShow({ title: '专属推广邀请码已复制到剪切板', desc: '' })
          },
          (err) => {
            console.error('无法复制此文本：', err)
          }
        )
      }
    },
    applyCode () {
      applyCode().then(res => {
        this.promotion_code = res.data.data
        this.getUser()
      }).catch((err) => {
        console.log(err)
      })
    },
    getUser () {
      getCurrentUser().then(res => {
        this.$store.state.user = res.data.data
        localStorage.setItem('hyy_www_user', JSON.stringify(this.user))
      }).catch(err => { console.log(err) })
    },
    view (row) {
      getDetail(row.Key).then(res => {
        this.versionDialog = true
        this.row = res.data.data
      }).catch((err) => {
        console.log(err)
      })
    },
    changePage (page) {
      this.query.PageIndex = page
    },
    notifyShow (msg = { title: '', desc: '', timeout: 3000 }) {
      this.$refs.notify.show(msg)
    },
    refreshData: debounce(
      function () {
        this.getList()
      },
      800
    ),
    getList () {
      this.loading = true
      pageList(this.queryString).then(res => {
        const data = res.data.data
        if (!data.list) data.list = []
        this.tableData = data.list
        this.query.PageIndex = data.page
        this.total = data.total
        // this.$refs.multipleTable.doLayout()
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    query: {
      handler: function () {
        this.refreshData()
      },
      deep: true
    }
  },
  computed: {
    queryString: function () {
      return Object.keys(this.query).filter(key => this.query[key] !== '')
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.query[key]))
        .join('&')
    }
  }
}
</script>
